import { render, staticRenderFns } from "./ShowHeader.vue?vue&type=template&id=494f3c47&"
import script from "./ShowHeader.vue?vue&type=script&lang=ts&"
export * from "./ShowHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ShowHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnimateText: require('/tmp/build_dc55b0b5/src/components/animate/AnimateText.vue').default,Button: require('/tmp/build_dc55b0b5/src/components/button/Button.vue').default,InlineVideo: require('/tmp/build_dc55b0b5/src/components/media/InlineVideo.vue').default,AdaptiveImageNew: require('/tmp/build_dc55b0b5/src/components/media/AdaptiveImageNew.vue').default,IconsPlay: require('/tmp/build_dc55b0b5/src/components/icons/play.vue').default,ButtonCircle: require('/tmp/build_dc55b0b5/src/components/button/Circle.vue').default,Button: require('/tmp/build_dc55b0b5/src/components/button/Button.vue').default,ModalVideoPlayer: require('/tmp/build_dc55b0b5/src/components/modal/VideoPlayer.vue').default,ShowsDateListItem: require('/tmp/build_dc55b0b5/src/components/shows/DateListItem.vue').default,Modal: require('/tmp/build_dc55b0b5/src/components/modal/Modal.vue').default})
